// extracted by mini-css-extract-plugin
export default {"container":"AuthSalesforceCanvas_container__t8AJm"};